import ar from './ar';
import bg from './bg';
import ca from './ca';
import cs from './cs';
import de from './de';
import el from './el';
import en from './en';
import es from './es';
import fa from './fa';
import fi from './fi';
import fr from './fr';
import he from './he';
import hr from './hr';
import it from './it';
import ja from './ja';
import ko from './ko';
import lt from './lt';
import no from './no';
import pl from './pl';
import ptBR from './pt-BR';
import ro from './ro';
import ru from './ru';
import sk from './sk';
import sl from './sl';
import sr from './sr';
import sv from './sv';
import tr from './tr';
import uz from './uz';
import vi from './vi';
import zhHans from './zh-Hans';
import zhHant from './zh-Hant';

const languages = {
  ar,
  bg,
  ca,
  cs,
  de,
  el,
  en,
  es,
  fa,
  fi,
  fr,
  he,
  hr,
  it,
  ja,
  ko,
  lt,
  no,
  pl,
  'pt-BR': ptBR,
  ro,
  ru,
  sk,
  sl,
  sr,
  sv,
  tr,
  uz,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};

export const supportedLanguages = Object.keys(languages);

export function getLanguage() {
  const storedLanguage = localStorage.getItem('language');

  if (storedLanguage && languages[storedLanguage]) {
    return storedLanguage;
  }

  const browserLanguage = navigator.language || 'en';

  if (languages[browserLanguage]) {
    return browserLanguage;
  }

  if (browserLanguage.toLowerCase().startsWith('zh-')) {
    const normalizedChineseLanguage = browserLanguage.toLowerCase();

    if (
      normalizedChineseLanguage.includes('tw') ||
      normalizedChineseLanguage.includes('hk') ||
      normalizedChineseLanguage.includes('mo') ||
      normalizedChineseLanguage.includes('hant')
    ) {
      return 'zh-Hant';
    }

    return 'zh-Hans';
  }

  if (browserLanguage.toLowerCase() === 'pt-br') {
    return 'pt-BR';
  }

  const baseLanguage = browserLanguage.split('-')[0];

  if (languages[baseLanguage]) {
    return baseLanguage;
  }

  return 'en';
}

export function t(key) {
  const language = getLanguage();
  return languages[language]?.[key] ?? languages.en[key] ?? key;
}

export { languages };
